// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileNav_wrapper__QKFbs","body":"MobileNav_body__Q6r90","bodyRight":"MobileNav_bodyRight__3RLFY","menu":"MobileNav_menu__RUrT7","brandLogo":"MobileNav_brandLogo__cXIpS"};